// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { bootstrapTextScale } from './components/a11y/AccessibilityWidget';

// Applies the product-wide UI scale (`uiScale` in src/theme/designTokens.js)
// before the first render, so no page ever paints at 100% and then snaps.
bootstrapTextScale();

// Create root once
const rootEl = document.getElementById('root');
const root = ReactDOM.createRoot(rootEl);

// StrictMode is dev-only overhead; fine to leave on.
// In production builds it doesn’t affect perf.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enhanced web vitals monitoring
reportWebVitals(metric => {
  // Log vital metrics
  const { name, value, id } = metric;
  
  // You can send these metrics to your analytics service
  if (process.env.NODE_ENV === 'production') {
    console.log(`Web Vital: ${name} - ${value} (ID: ${id})`);
    // Add your analytics code here
  }
});
